import { render, staticRenderFns } from "./DefaultGDQShortMailTexts.vue?vue&type=template&id=44a4b5e0&"
import script from "./DefaultGDQShortMailTexts.vue?vue&type=script&lang=js&"
export * from "./DefaultGDQShortMailTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports